import { getLocalizedMusicGenre } from '../../../../features/taste/generated/localization';

// Submitted build58 AlbumDetailScreen + taste/localization: display only.
export function albumReleaseDate(value) {
  if (!value) return '';
  const match = value.match(/^(\d{4})[-.](\d{1,2})[-.](\d{1,2})/);
  return match ? `${match[1]}.${match[2].padStart(2, '0')}.${match[3].padStart(2, '0')}` : value;
}
export function albumGenre(value, locale) {
  return getLocalizedMusicGenre(value, locale);
}
export function albumMetadata(album, locale) {
  return [
    albumReleaseDate(album.releaseDate),
    album.genres?.map((genre) => albumGenre(genre, locale)).join(', '),
  ]
    .filter(Boolean)
    .join(' · ');
}
export function memberReviewCount(reviews = []) {
  return new Set(
    reviews.filter((review) => Boolean(review.content?.trim())).map((review) => review.user.id),
  ).size;
}
export function albumRecordCount(value, locale) {
  return new Intl.NumberFormat(locale === 'en' ? 'en-US' : 'ko-KR').format(
    Math.max(0, Math.round(Number(value) || 0)),
  );
}
